import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import $ from "jquery";
import "./jquery.pause.min.js";

import arrow from "./img/arrow.svg";

import P2Plunger from "./img/P2-Plunger.svg";
import P2NoTip from "./img/P2.svg";
import P2Tip from "./img/P2-Tip.svg";
import P2TipSolution from "./img/P2-Tip-Solution-Blue.svg";

import P20Plunger from "./img/P20-Plunger.svg";
import P20NoTip from "./img/P20.svg";
import P20Tip from "./img/P20-Tip.svg";
import P20TipSolution from "./img/P20-Tip-Solution-Blue.svg";

import P200Plunger from "./img/P200-Plunger.svg";
import P200NoTip from "./img/P200.svg";
import P200Tip from "./img/P200-Tip.svg";
import P200TipSolution from "./img/P200-Tip-Solution-Blue.svg";

import P1000Plunger from "./img/P1000-Plunger.svg";
import P1000NoTip from "./img/P1000.svg";
import P1000Tip from "./img/P1000-Tip.svg";
import P1000TipSolution from "./img/P1000-Tip-Solution-Blue.svg";

const images = {
  P2Plunger: P2Plunger,
  P2NoTip: P2NoTip,
  P2Tip: P2Tip,
  P2TipSolution: P2TipSolution,
  P20Plunger: P20Plunger,
  P20NoTip: P20NoTip,
  P20Tip: P20Tip,
  P20TipSolution: P20TipSolution,
  P200Plunger: P200Plunger,
  P200NoTip: P200NoTip,
  P200Tip: P200Tip,
  P200TipSolution: P200TipSolution,
  P1000Plunger: P1000Plunger,
  P1000NoTip: P1000NoTip,
  P1000Tip: P1000Tip,
  P1000TipSolution: P1000TipSolution,
};

export function GelLanePipette(props) {
  const { t } = useTranslation();

  const getPipetteAltText = (type) => {
    let alt = "";
    switch (type) {
      case "P2":
        alt = t("P2Micropipette.string");
        break;
      case "P20":
        alt = t("P20Micropipette.string");
        break;
      case "P200":
        alt = t("P200Micropipette.string");
        break;
      case "P1000":
        alt = t("P1000Micropipette.string");
        break;
    }
    return alt;
  };

  const ref = useRef();
  const [first, setFirst] = useState();
  const [hold, setHold] = useState(false);
  const [fired, setFired] = useState(false);
  const [, setPlungerPosition] = useState("Release");

  useEffect(() => {
    if (ref.current) {
      setFirst(ref.current.getBoundingClientRect());
    }
  }, []);

  const getDuration = (offset, hold) => {
    let duration;

    if (hold) {
      duration = (20 + offset) * 20;
    } else {
      duration = -offset * 20;
    }

    return duration > 0 ? duration : 0;
  };

  const depositSolution = () => {
    const gelId = 1; // update
    const lane = parseInt(props.selectedLane.replace("lane", ""));

    const solution = {};
    let totalVolume = 0;

    if (
      props.interactionProps.pipettes[props.pipetteId - 1].solution !== null
    ) {
      for (const sol in props.interactionProps.pipettes[props.pipetteId - 1]
        .solution) {
        solution[sol] =
          props.interactionProps.pipettes[props.pipetteId - 1].solution[sol];
        totalVolume +=
          props.interactionProps.pipettes[props.pipetteId - 1].solution[sol];
      }
    }

    if (totalVolume > 0) {
      if (typeof lane !== "undefined" && lane > 0) {
        //HERE: All actions to reducers to set final outcomes
        props.setGelLane({
          id: gelId,
          laneNumber: lane,
          laneData: {
            volume: totalVolume,
            solutions: solution,
            solutionAlias:
              props.interactionProps.pipettes[props.pipetteId - 1]
                .solutionAlias,
            fragments:
              props.interactionProps.pipettes[props.pipetteId - 1].fragments,
            particulate: null, // needed?
            empty: false,
          },
        });

        props.setPipetteSolution({
          id: props.pipetteId,
          solution: null,
          fragments: null,
          solutionAlias: null,
        });
      }
    }
  };

  const updatePlungerPos = (offset, hold) => {
    if (offset < 25) {
      setPlungerPosition("Release");
    } else if (offset < 50) {
      if (hold && !fired) {
        setFired(true);
        depositSolution();
      }
      setPlungerPosition("1st Stop");
    } else if (offset >= 40) {
      setPlungerPosition("2nd Stop");
    }
  };

  const animatePlunger = () => {
    if (ref.current && first) {
      const last = ref.current.getBoundingClientRect();
      const deltaY = last.top - first.top;

      if (hold) {
        $(ref.current).animate(
          {
            marginTop: 25,
          },
          {
            duration: getDuration(-deltaY, hold),
            easing: "linear",
            step: (now) => {
              console.log("Step: " + now);
              updatePlungerPos(now, hold);
            },
          }
        );
      } else {
        $(ref.current).animate(
          {
            marginTop: 0,
          },
          {
            duration: getDuration(-deltaY, hold),
            easing: "linear",
            step: (now) => {
              console.log("Step: " + now);
              updatePlungerPos(now, hold);
            },
          }
        );
      }
    }
  };

  useEffect(() => {
    animatePlunger();
  }, [hold]);

  return (
    <div className={`${props.className}_block`}>
      <div className={props.className}>
        <h3 className={`${props.className}_header`}>
          {t("PressPlunger.string")}
        </h3>
        <div className={`${props.className}_pipettePlunger`}>
          {props.pipetteId !== null ? (
            <>
              <button
                onMouseDown={() => {
                  if (!$(ref.current).is(":animated")) {
                    setHold(true);
                  }
                }}
                onMouseUp={() => setHold(false)}
                onMouseOut={() => setHold(false)}
                onBlur={() => setHold(false)}
              >
                {/*plungerPosition*/}
              </button>
              <div className="positionWrap">
                <p>{t("Release.string")}</p>
                <p>{t("1stStop.string")}</p>
                <p>{t("2ndStop.string")}</p>
              </div>
              <div className="imageWrap">
                <img src={arrow} alt="" className="arrow" />
                <img
                  ref={ref}
                  className={props.type + "-pipette pipettePlunger"}
                  src={
                    images[
                      props.interactionProps.pipettes[props.pipetteId - 1]
                        .type + "Plunger"
                    ]
                  }
                  alt={getPipetteAltText(
                    props.interactionProps.pipettes[props.pipetteId - 1].type
                  )}
                />
                <img
                  className={props.type + "-pipette pipette"}
                  src={
                    props.interactionProps.pipettes[props.pipetteId - 1]
                      .tipAttached
                      ? props.interactionProps.pipettes[props.pipetteId - 1]
                          .solution !== null
                        ? images[
                            props.interactionProps.pipettes[props.pipetteId - 1]
                              .type + "TipSolution"
                          ]
                        : images[
                            props.interactionProps.pipettes[props.pipetteId - 1]
                              .type + "Tip"
                          ]
                      : images[
                          props.interactionProps.pipettes[props.pipetteId - 1]
                            .type + "NoTip"
                        ]
                  }
                  alt={getPipetteAltText(
                    props.interactionProps.pipettes[props.pipetteId - 1].type
                  )}
                />
              </div>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
}

GelLanePipette.propTypes = {
  /**
   * ClassName to set on status warning component
   */
  className: PropTypes.string,
  /**
   * Boolean to set the Microcentrifuge Balanced Status Yes/No
   */
  lanes: PropTypes.array,

  pipetteId: PropTypes.int,
  interactionProps: PropTypes.object,
  selectedLane: PropTypes.string,
  setGelLane: PropTypes.func,
  setPipetteSolution: PropTypes.func,
  alert: PropTypes.func,
};

GelLanePipette.defaultProps = {};
